import axios from "axios";
import store from "@/general/store";
import {
  Module,
  VuexModule,
  Mutation,
  getModule,
  Action
} from "vuex-module-decorators";

@Module({
  name: "items",
  namespaced: true,
  store,
  dynamic: true
})
class ItemsModule extends VuexModule {
  items: any = [];
  histories: any = [];
  recommendations: any = [];
  favorites: any = [];
  rankingCategory0: any = [];
  rankingCategory1: any = [];
  rankingCategory2: any = [];
  rankingCategory3: any = [];
  rankingPointRange0: any = [];
  rankingPointRange1: any = [];
  rankingPointRange2: any = [];
  rankingPointRange3: any = [];
  item: Record<string, any> = {};

  @Mutation
  setItems(items: any) {
    this.items = items;
  }
  @Mutation
  setHistories(histories: any) {
    this.histories = histories;
  }
  @Mutation
  setRecommendations(recommendations: any) {
    this.recommendations = recommendations;
  }
  @Mutation
  setFavorites(favorites: any) {
    this.favorites = favorites;
  }
  @Mutation
  setRanking({ categroyID, items }: any) {
    switch (categroyID) {
      case "category0":
        this.rankingCategory0 = items;
        break;
      case "category1":
        this.rankingCategory1 = items;
        break;
      case "category2":
        this.rankingCategory2 = items;
        break;
      case "category3":
        this.rankingCategory3 = items;
        break;
      case "pointRange0":
        this.rankingPointRange0 = items;
        break;
      case "pointRange1":
        this.rankingPointRange1 = items;
        break;
      case "pointRange2":
        this.rankingPointRange2 = items;
        break;
      case "pointRange3":
        this.rankingPointRange3 = items;
        break;
      default:
        break;
    }
  }
  @Mutation
  setItem(item: Record<string, any>) {
    this.item = item;
  }

  @Action
  getItems() {
    axios.get("/api/general/items/").then(response => {
      this.context.commit("setItems", response.data.items);
    });
    // TODO: error handling
    // .catch((error) => {
    //   console.log(error);
    // });
  }
  @Action
  getHistories() {
    axios.get("/api/general/history/").then(response => {
      this.context.commit("setHistories", response.data.items);
    });
    // TODO: error handling
    // .catch((error) => {
    //   console.log(error);
    // });
  }
  @Action
  getRecommendations() {
    axios.get("/api/general/recommendation/").then(response => {
      this.context.commit("setRecommendations", response.data.items);
    });
    // TODO: error handling
    // .catch((error) => {
    //   console.log(error);
    // });
  }
  @Action
  getFavorites() {
    axios.get("/api/general/favorite/").then(response => {
      this.context.commit("setFavorites", response.data.items);
    });
    // TODO: error handling
    // .catch((error) => {
    //   console.log(error);
    // });
  }
  @Action
  postFavorites({ id, isFavorite }: any) {
    axios.post("/api/general/favorite/", { id, isFavorite }).then(response => {
      this.context.commit("setFavorites", response.data.items);
    });
    // TODO: error handling
    // .catch((error) => {
    //   console.log(error);
    // });
  }
  @Action
  getRanking(id: number) {
    axios.get(`/api/general/ranking/${id}`).then(response => {
      this.context.commit("setRanking", response.data);
    });
  }
  @Action
  getItem(id: number) {
    axios.get(`/api/general/items/${id}`).then(response => {
      this.context.commit("setItem", response.data.item);
    });
  }
  @Action
  postFavorite(id: number) {
    axios.post(`/api/general/items/${id}/favorite`).then(response => {
      this.context.commit("setItem", response.data.item);
    });
  }
  @Action
  deleteFavorite(id: number) {
    axios.delete(`/api/general/items/${id}/favorite`).then(response => {
      this.context.commit("setItem", response.data.item);
    });
  }
}

export default getModule(ItemsModule);
